/** Food subscription / platform fee fields on restaurant orders (JREATS). */

export function resolveOrderBillingType(order) {
  const raw = order?.billingType ?? order?.billing_type ?? 'REGULAR';
  const normalized = String(raw).trim().toUpperCase();
  return normalized || 'REGULAR';
}

export function isSubscriptionCreditOrder(order) {
  return resolveOrderBillingType(order) === 'SUBSCRIPTION-CREDIT';
}

export function formatOrderBillingLabel(order) {
  return isSubscriptionCreditOrder(order) ? 'Subscription' : 'Regular';
}

export function resolveOrderSubscriptionId(order) {
  const value = order?.subscriptionId ?? order?.subscription_id;
  return value == null || value === '' ? null : value;
}

export function resolveOrderCreditsConsumed(order) {
  const value = order?.creditsConsumed ?? order?.credits_consumed;
  return value == null || value === '' ? null : value;
}

export function resolveRestaurantSettlementAmount(order) {
  const value =
    order?.restaurantSettlementAmount ?? order?.restaurant_settlement_amount ?? null;
  return value == null || value === '' ? null : value;
}

export function resolveOrderPlatformFee(order) {
  const value = order?.platformFee ?? order?.Platform_Fee ?? order?.platform_fee ?? null;
  return value == null || value === '' ? null : value;
}

export function formatOrderMoney(amount) {
  const n = parseFloat(amount);
  if (Number.isNaN(n)) return '—';
  return `₹${n.toFixed(2)}`;
}

export function attachOrderBillingFields(order) {
  if (!order || typeof order !== 'object') return order;

  const billingType = resolveOrderBillingType(order);
  const subscriptionId = resolveOrderSubscriptionId(order);
  const creditsConsumed = resolveOrderCreditsConsumed(order);
  const restaurantSettlementAmount = resolveRestaurantSettlementAmount(order);
  const platformFee = resolveOrderPlatformFee(order);

  return {
    ...order,
    billingType,
    billing_type: billingType,
    subscriptionId,
    subscription_id: subscriptionId,
    creditsConsumed,
    credits_consumed: creditsConsumed,
    restaurantSettlementAmount,
    restaurant_settlement_amount: restaurantSettlementAmount,
    platformFee,
    platform_fee: platformFee,
  };
}
